(() => {
  const normalise = root => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = root.nodeType === Node.TEXT_NODE ? [root] : [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement?.closest('script, style, textarea, input, [contenteditable]')) continue;
      const next = node.data.replace(/\bRs\.\s*(?=\d)/g, '₹');
      if (next !== node.data) node.data = next;
    }
  };
  normalise(document.body);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'characterData') normalise(record.target);
      else for (const node of record.addedNodes) normalise(node);
    }
  }).observe(document.body, { childList: true, characterData: true, subtree: true });
})();
